import React, {
  Fragment 
} from "react"

import {
  useStyle 
} from "@/classify"
import RichContent from "@/components/RichContent"
import defaultClasses from "./multiselect.module.css"

/**
 * Custom Attributes Multiselect Type component.
 *
 * @typedef Multiselect
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a Multiselect Type Product Attribute.
 */
const Multiselect = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const {
    attribute_metadata = {}, selected_attribute_options = {} 
  } = props

  const attributeLabel = attribute_metadata.label ? (
    <div className={classes.label}>{attribute_metadata.label}</div>
  ) : null
  let attributeContent

  if (selected_attribute_options.attribute_option?.length > 0) {
    const {
      is_html_allowed: isHtml 
    } = attribute_metadata.ui_input

    if (isHtml) {
      const options = selected_attribute_options.attribute_option.map((option, key) => {
        return (
          // TODO: Get decoded wysiwyg widgets from GraphQl
          <RichContent
            classes={{
              root: classes.option 
            }}
            key={key}
            html={option.label}
          />
        )
      })

      attributeContent = (
        <div className={classes.contentHtml}>{options}</div>
      )
    } else {
      const options = selected_attribute_options.attribute_option
        .map((option) => option.label)
        .join(", ")

      attributeContent = <div className={classes.content}>{options}</div>
    }
  }

  return (
    <Fragment>
      {attributeLabel}
      {attributeContent}
    </Fragment>
  )
}

export default Multiselect
